import React, { useEffect } from "react"
import { motion } from "framer-motion"
import { Loader } from "lucide-react"

function Spinner() {
	return (
		<motion.div
			animate={{ rotate: 360 }}
			transition={{ duration: 2, repeat: Infinity, type: "spring", bounce: 0.5 }}
		>
			<Loader size={100} className='text-slate-500' />
		</motion.div>
	)
}

export default Spinner
